import React, { useEffect, useState } from 'react'
import {
  getProfileImage,
  postCheckEmail,
  postCheckNickname,
  postCreateUser,
  postFindUser,
  postLogin,
  postProfileImage,
  postUserPolicies,
} from '../../api/login'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'

import { useNavigate } from 'react-router-dom'
import { postOpenid } from '../../api/auth'
import { PictureModal } from '../../components/myshopping/PictureModal'
import { handleAccessToken } from '../../js/script'

export default function SignInfo({ phoneNumber, os, verificationCheckCode, setText, policy }: any) {
  const [nickName, setNickName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [recommend, setRecommend] = useState<any>({})
  const [nicknameCheck, setNicknameCheck] = useState<boolean>(false)
  const [emailCheck, setEmailCheck] = useState<boolean>(false)
  const [select, setSelect] = useState<any>()
  const [isPictureModal, setIsPictureModal] = useState<boolean>(false)
  const [imageUrls, setImageUrls] = useState<any>([])
  const [profileImages, setProfileImages] = useState<any>([])
  const [checkRecommend, setCheckRecommend] = useState<boolean>(false)
  const navigate = useNavigate()

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    getProfileImage()
      .then((res) => {
        setProfileImages(res.data)

        // 모든 이미지 URL을 추출하여 한 번에 상태 업데이트
        const urls = res.data.map((el: any) => el.png)
        setImageUrls(urls)
      })
      .catch((err) => console.log(err))
  }, [])

  function uploadFile(e: any) {
    if (!e.target.files) {
      return
    }
    const pictureSize = e.target.files[0].size
    const maxSize = 5 * 1024 * 1024
    if (pictureSize > maxSize) {
      alert('첨부할 수 있는 이미지 파일은 5MB이하입니다.')
      return
    }
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    postProfileImage(formData)
      .then((res) => {
        setSelect(res.data.url)
      })
      .catch((err) => console.log(err))
  }

  function getRandomElement(arr: string[]) {
    // Math.random()을 사용하여 0과 배열의 길이 사이의 랜덤 인덱스를 생성합니다.
    const randomIndex = Math.floor(Math.random() * arr.length)
    setSelect(arr[randomIndex])
  }

  useEffect(() => {
    getRandomElement(imageUrls)
  }, [imageUrls])

  return (
    <>
      <PageTitle className='small' style={{ padding: '0 20px 12px' }}>
        기본정보 입력
      </PageTitle>

      <div className='profile_wrap'>
        <div className='profile_img_cont img_list'>
          <div className='select_img'>
            <div
              className='imb_box join'
              onClick={() => {
                setIsPictureModal(true)
              }}
            >
              <div
                className='img'
                style={{
                  backgroundImage: `url(${select})`,
                }}
              ></div>
            </div>
          </div>
        </div>
        <div className='profile_info join'>
          <div className='inp_box'>
            <p>
              <b>
                닉네임<sup>*</sup>
              </b>
              {nicknameCheck ? <em>사용할 수 없는 닉네임입니다.</em> : null}
            </p>
            <input
              type='text'
              placeholder='한글 2자 이상 8자 이하(영문 4byte~16byte)'
              onChange={(e) => {
                setNickName(e.target.value)
                const regex = /^([가-힣]{2,8}|[a-zA-Z]{4,16})$/
                if (regex.test(e.target.value)) {
                  postCheckNickname(e.target.value)
                    .then((res) => {
                      if (res.data.message === 'ok') {
                        setNicknameCheck(false)
                      } else {
                        setNicknameCheck(true)
                      }
                    })
                    .catch((err) => console.log(err))
                } else {
                  setNicknameCheck(true)
                }
                if (e.target.value.length === 0) {
                  setNicknameCheck(false)
                }
              }}
            />
          </div>
          <div className='inp_box'>
            <p>
              <b>
                이메일<sup>*</sup>
              </b>
              {emailCheck ? <em>사용할 수 없는 이메일입니다.</em> : null}
            </p>
            <input
              type='text'
              placeholder='이메일을 입력해주세요.'
              onChange={(e) => {
                setEmail(e.target.value)
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                if (emailRegex.test(e.target.value)) {
                  postCheckEmail(e.target.value)
                    .then((res) => {
                      if (res.data.message === 'ok') {
                        setEmailCheck(false)
                      } else {
                        setEmailCheck(true)
                      }
                    })
                    .catch((err) => console.log(err))
                } else {
                  setEmailCheck(true)
                }
                if (e.target.value.length === 0) {
                  setEmailCheck(false)
                }
              }}
            />
            <span>
              휴대폰번호가 바뀌게 되면 사용자 확인 용도로 쓰입니다. <br />
              정확하게 입력해주세요.
            </span>
          </div>
          <div className='inp_box'>
            <p>
              추천인 닉네임
              {!checkRecommend ? null : <em>회원이 아닙니다.</em>}
            </p>
            <input
              type='text'
              className={!checkRecommend ? '' : 'fail'}
              placeholder='추천인 닉네임을 입력해주세요.'
              onChange={(e) => {
                const regex = /^([가-힣]{2,8}|[a-zA-Z]{4,16})$/
                if (regex.test(e.target.value)) {
                  postFindUser(e.target.value).then((res) => {
                    if (res.data.message === 'ok') {
                      setCheckRecommend(false)
                      setRecommend(res.data.user)
                    } else {
                      setCheckRecommend(true)
                    }
                  })
                } else {
                  setCheckRecommend(true)
                }
                if (e.target.value.length === 0) {
                  setCheckRecommend(false)
                }
              }}
            />
          </div>
        </div>
        <div className='modal_footer'>
          {!nicknameCheck &&
          !emailCheck &&
          nickName !== '' &&
          email !== '' &&
          !checkRecommend &&
          (!checkRecommend || recommend) ? (
            <button
              type='submit'
              className='btn_save'
              style={{
                borderRadius: 0,
              }}
              onClick={() => {
                if (!emailCheck && !nicknameCheck && email.length !== 0 && nickName.length !== 0) {
                  postCreateUser(
                    email,
                    nickName,
                    phoneNumber,
                    recommend.id,
                    verificationCheckCode,
                    os,
                    select,
                    true,
                    'mobile',
                    email
                  )
                    .then((res) => {
                      postLogin(phoneNumber, verificationCheckCode, os)
                        .then((res) => {
                          if (res.data.code === 'E0123') {
                            alert(res.data.code)
                          } else if (res.data.code === 'E0127') {
                            alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0125') {
                            alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
                          } else if (res.data.code === 'E0111') {
                            navigate(`/sanctions`, {
                              state: { userData: res.data },
                            })
                          } else {
                            window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
                            window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
                            postUserPolicies(policy, res.data.accessToken)
                              .then((res) => {})
                              .catch((err) => {
                                console.log(err)
                              })
                            postOpenid(res.data.accessToken)
                              .then((res) => {
                                window.localStorage.setItem(`accessToken`, JSON.stringify(res.data.accessToken))
                                // closeModal();
                                handleAccessToken()
                                setText('signUpCompleted')
                              })
                              .catch((err) => console.log(err))
                          }
                        })
                        .catch((err) => console.log(err))
                    })
                    .catch((err) => console.log(err))
                } else if (checkRecommend) {
                  alert('추천인을 확인해주세요')
                  return
                } else {
                  alert('이메일 또는 닉네임을 확인해주세요')
                  return
                }
              }}
            >
              확인
            </button>
          ) : (
            <button
              type='submit'
              className='btn_save'
              style={{
                background: 'var(--colGray2)',
                color: 'var(--colGray4)',
              }}
            >
              확인
            </button>
          )}
          {/* {!nicknameCheck && nickName && !emailCheck && email ? (
            <button
              type="submit"
              className="btn_save"
              style={{
                background: "var(--colGray2)",
                color: "var(--colGray4)",
              }}
            >
              확인
            </button>
          ) : (
            <button
              type="submit"
              className="btn_save"
              onClick={() => {
                if (
                  !emailCheck &&
                  !nicknameCheck &&
                  email.length !== 0 &&
                  nickName.length !== 0
                ) {
                  postCreateUser(
                    email,
                    nickName,
                    phoneNumber,
                    recommend.id,
                    verificationCheckCode,
                    os,
                    select
                  )
                    .then((res) => {
                      postLogin(phoneNumber, verificationCheckCode, os)
                        .then((res) => {
                          if (res.data.code === "E0123") {
                            alert(res.data.code);
                          } else if (res.data.code === "E0127") {
                            alert("회원탈퇴 한지 7일이 지나지 않았습니다.");
                          } else if (res.data.code === "E0125") {
                            alert("회원탈퇴 한지 180일이 지나지 않았습니다.");
                          } else if (res.data.code === "E0111") {
                            navigate(`/sanctions`, {
                              state: { userData: res.data },
                            });
                          } else {
                            window.localStorage.setItem(
                              `aboutRefreshToken`,
                              JSON.stringify(res.data.refreshToken)
                            );
                            window.localStorage.setItem(
                              `aboutAccessToken`,
                              JSON.stringify(res.data.accessToken)
                            );
                            postOpenid(res.data.accessToken)
                              .then((res) => {
                                window.localStorage.setItem(
                                  `accessToken`,
                                  JSON.stringify(res.data.accessToken)
                                );
                                closeModal();
                                handleAccessToken();
                                navigate("/SignUpCompleted");
                              })
                              .catch((err) => console.log(err));
                          }
                        })
                        .catch((err) => console.log(err));
                    })
                    .catch((err) => console.log(err));
                } else if (checkRecommend) {
                  alert("추천인을 확인해주세요");
                  return;
                } else {
                  alert("이메일 또는 닉네임을 확인해주세요");
                  return;
                }
              }}
            >
              확인
            </button>
          )} */}
        </div>
      </div>
      {isPictureModal ? (
        <PictureModal
          profileImages={profileImages}
          setPictureModal={setIsPictureModal}
          setSelectImage={setSelect}
          profileImage={select}
          pictureModal={isPictureModal}
        />
      ) : null}
    </>
  )
}
